import { Sube } from './sube';
import { TalepTur } from './talep-tur';
import { UrunGrup } from './urun-grup';
import { Kullanici } from './kullanici';
import { TalepKalem } from './talep-kalem';
import { TalepOnaySeviye } from './talep-onay-seviye';
import { Teklif } from './teklif';
import { Master } from './master';
import { TalepGorsel } from './talep-gorsel';
import { TalepAciklama } from './talep-aciklama';
import { Cari } from './cari';
import { Fatura } from './fatura';

export class Talep {

  public static REDEDILDI = -1;
  public static DURUM_ONAY_SURECI = 0;
  public static DURUM_TEKLIF_TOPLA = 1;
  public static DURUM_SIPARIS_OLUSTURULDU = 2;
  public static DURUM_IRSALIYE_OLUSTURULDU = 3;

  public static TALEP_TUR_ACIL = 1;
  public static TALEP_TUR_SATINALMA = 2;
  public static TALEP_TUR_YEREL = 3;

  id: number;
  sube: Sube;
  talepTur: TalepTur;
  urunGrup: UrunGrup;
  private olusturmaTarihi: string;
  durum: number;
  kullanici: Kullanici;
  subeId: number;
  talepTurId: number;
  urunGrupId: number;
  teslimYeriId: number;
  aciklama: string;
  teslimYeri: Master;
  private pTalepKalemler: TalepKalem[];
  private pTalepGorseller: TalepGorsel[];
  // private pTalepTalepOnaySeviyeler: TalepTalepOnaySeviyeler[];
  talepOnaySeviye: TalepOnaySeviye;
  talepOnaySeviyeId: number;
  pTeklifler: Teklif[];
  talepAciklamalar: TalepAciklama[];
  talepNo: string;
  cari: Cari;
  fatura: Fatura;
  toplamTalepEdilenMiktar: number;
  toplamSiparisEdilenMiktar: number;
  urunGrupText: string;
  isTeklifFiyatDegisti: boolean;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.sube != null) {
      this.sube = new Sube(obj.sube);
    }
    if (obj.talepTur != null) {
      this.talepTur = new TalepTur(obj.talepTur);
    }
    if (obj.urunGrup != null) {
      this.urunGrup = new UrunGrup(obj.urunGrup);
    }
    if (obj.kullanici != null) {
      this.kullanici = new Kullanici(obj.kullanici);
    }
  }

  public get talepKalemler(): TalepKalem[] {
    return this.pTalepKalemler;
  }

  public set talepKalemler(list: TalepKalem[]) {
    if (list != null) {
      this.pTalepKalemler = list.map(t => new TalepKalem(t));
    }
  }

  public get talepGorseller(): TalepGorsel[] {
    return this.pTalepGorseller;
  }

  public set talepGorseller(list: TalepGorsel[]) {
    if (list != null) {
      this.pTalepGorseller = list.map(t => new TalepGorsel(t));
    }
  }

  public get teklifler(): Teklif[] {
    return this.pTeklifler;
  }

  public set teklifler(list: Teklif[]) {
    if (list != null) {
      this.pTeklifler = list.map(t => new Teklif(t));
    }
  }

  get olusturmaTarihiText(): string {
    if (this.olusturmaTarihi != null) {
      const date = new Date(this.olusturmaTarihi);
      return date.toLocaleString();
    }
    return '';
  }

  get durumText(): string {
    if (this.durum != null) {
      if (this.durum === Talep.DURUM_ONAY_SURECI)
        return this.talepOnaySeviye?.kullaniciGrup?.isim + ' Onayında';
      else if (this.durum === Talep.DURUM_TEKLIF_TOPLA && this.talepTur?.id === Talep.TALEP_TUR_YEREL) {
        return 'Sipariş Oluşturuldu';
      }
      else {
        return Talep.getDurumText(this.durum);
      }
    }
    return '';
  }

  public static getDurumText(durum: number): string {
    if (durum != null) {
      switch (durum) {
        case Talep.REDEDILDI:
          return 'Rededildi';
        case Talep.DURUM_ONAY_SURECI:
          return 'Onay Sürecinde';
        case Talep.DURUM_TEKLIF_TOPLA:
          return 'Teklif Toplanıyor';
        case Talep.DURUM_SIPARIS_OLUSTURULDU:
          return 'Sipariş Oluşturuldu';
        case Talep.DURUM_IRSALIYE_OLUSTURULDU:
          return 'İrsaliye Oluşturuldu';
      }
    }
    return '';
  }
}
